<template>
  <div>
    <v-container fluid>
      <div class="text-xs-right my-2">
        <v-btn depressed @click="onExport" :loading="loading" color="primary">
          <v-icon class="mr-2">upgrade</v-icon>
          {{ $t('export') }}
        </v-btn>
      </div>
      <v-data-table
        :headers="headers"
        :items="users"
        class="elevation-1"
        :loading="loading"
        v-bind:pagination.sync="pagination"
        :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      >
        <template v-slot:items="props">
          <td>
            <v-btn fab flat small @click="selectUser(props.item)"
              ><v-icon small>search</v-icon></v-btn
            >
          </td>
          <td>
            {{ props.item.first_name }}
          </td>
          <td>
            {{ props.item.last_name }}
          </td>
          <td>
            {{ props.item.state }}
          </td>
          <td>
            {{ props.item.current_intentid }}
          </td>
          <td>
            {{ props.item.consent_accepted }}
          </td>
          <td>
            {{ props.item.total }}
          </td>
          <td>
            {{ props.item.score }}
          </td>
          <td>
            {{ props.item.session }}
          </td>
          <td>
            {{ props.item.sessionvalue }}
          </td>
          <td>
            {{ props.item.survey_completed_at }}
          </td>
          <td>
            {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
          </td>
        </template>
      </v-data-table>
      <v-dialog scrollable v-model="showUser" max-width="800">
        <v-card>
          <div class="text-xs-right">
            <v-btn small flat fab @click="showUser = false"> <v-icon small>close</v-icon></v-btn>
          </div>
          <v-divider></v-divider>
          <v-card-text v-if="currentUser" max-height="600">
            <v-layout wrap>
              <v-flex xs12 sm3 class="my-2">ID</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.id }}</v-flex>

              <v-flex xs12 sm3 class="my-2">First name</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.first_name }}</v-flex>
              <v-flex xs12 sm3 class="my-2">Last name</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.last_name }}</v-flex>
              <v-flex xs12 sm3 class="my-2">state</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.state }}</v-flex>

              <v-flex xs12 sm3 class="my-2">current_intentid</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{
                currentUser.current_intentid
              }}</v-flex>
              <v-flex xs12 sm3 class="my-2">total</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.total }}</v-flex>

              <v-flex xs12 sm3 class="my-2">session</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.session }}</v-flex>
              <v-flex xs12 sm3 class="my-2">sessionvalue</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.sessionvalue }}</v-flex>
              <v-flex xs12 sm3 class="my-2">score</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{ currentUser.score }}</v-flex>
              <v-flex xs12 sm3 class="my-2">consent_accepted</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{
                currentUser.consent_accepted
              }}</v-flex>
              <v-flex xs12 sm3 class="my-2">survey_completed_at</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{
                currentUser.survey_completed_at
              }}</v-flex>
              <v-flex xs12 sm3 class="my-2">timestamp</v-flex>
              <v-flex xs12 sm9 class="my-2 primary--text">{{
                currentUser.timestamp | DateFormat('DD/MM/YYYY HH:mm')
              }}</v-flex>
            </v-layout>
            <v-divider class="mt-4 mb-4"></v-divider>
            <h3 class="title mb-2">Current Variables</h3>
            <table style="width: 100%; border: 1px solid #eee; border-spacing: 0px;">
              <thead>
                <tr>
                  <td class="pa-2 font-weight-bold" style="border: 1px solid #eee">Name</td>
                  <td class="pa-2 font-weight-bold" style="border: 1px solid #eee">Value</td>
                  <td class="pa-2 font-weight-bold" style="border: 1px solid #eee">action</td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(val, index) in userCurrentVariable">
                  <edit-user
                    v-model="userCurrentVariable[index]"
                    :key="index + '_' + timestamp"
                    @save="updateCurrentUser"
                    @delete="deleteVariable(val.name)"
                  ></edit-user>
                </template>
              </tbody>
              <tfoot>
                <tr>
                  <td
                    class="pa-2 font-weight-bold text-xs-center"
                    style="border: 1px solid #eee"
                    colspan="3"
                    v-if="!isAdd"
                  >
                    <v-btn flat @click="isAdd = true"><v-icon>add</v-icon> Add new variable</v-btn>
                  </td>
                  <template v-else>
                    <td class="pa-2 font-weight-bold" style="border: 1px solid #eee">
                      <v-text-field
                        v-model="newVariable.name"
                        hide-details
                        outline
                        label="Name"
                      ></v-text-field>
                    </td>
                    <td class="pa-2 font-weight-bold" style="border: 1px solid #eee">
                      <v-text-field
                        v-model="newVariable.value"
                        hide-details
                        outline
                        label="Value"
                      ></v-text-field>
                    </td>
                    <td
                      class="pa-2 font-weight-bold"
                      style="border: 1px solid #eee; width: 1%; white-space: nowrap;"
                    >
                      <v-btn fab small depressed color="primary" @click="addVariable"
                        ><v-icon>check</v-icon></v-btn
                      >
                      <v-btn
                        fab
                        small
                        depressed
                        @click="
                          newVariable = { name: null, value: null }
                          isAdd = false
                        "
                        ><v-icon>close</v-icon></v-btn
                      >
                    </td>
                  </template>
                </tr>
              </tfoot>
            </table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import EditUser from './EditUser'
import api from '@/api'
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  data() {
    return {
      loading: true,
      total: 0,
      pagination: { rowsPerPage: 10 },
      headers: [
        { text: '', sortable: false },
        { text: 'First name', value: 'first_name' },
        { text: 'Last name', value: 'last_name' },
        { text: 'State', value: 'state' },
        { text: 'Current Intentid', value: 'current_intentid' },
        { text: 'Consent Accepted', value: 'consent_accepted' },
        { text: 'Total', value: 'total' },
        { text: 'Score', value: 'score' },
        { text: 'Session', value: 'session' },
        { text: 'Session Value', value: 'sessionvalue' },
        { text: 'Survey completed at', value: 'survey_completed_at' },
        { text: 'Timestamp', value: 'timestamp' }
      ],
      users: [],
      currentUser: null,
      showUser: false,
      isAdd: false,
      isEdit: false,
      newVariable: { name: null, value: null },
      userCurrentVariable: [],
      timestamp: moment().format('x')
    }
  },
  components: {
    EditUser
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.loading = true
    var response = await this.getallusersbybotorigin(0)
    this.total = response.total
    this.users = response.data
    this.loading = false
  },
  methods: {
    onExport() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      let json = []

      json = this.users.map(el => {
        return {
          'First name': el.first_name,
          'Last name': el.last_name,
          State: el.state,
          'Current Intentid': el.current_intentid,
          'Consent Accepted': el.consent_accepted,
          Total: el.total,
          Score: el.score,
          Session: el.session,
          'Session Value': el.sessionvalue,
          'Survey completed at': el.survey_completed_at,
          Timestamp: el.timestamp
        }
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'tunejai-users.xlsx')
    },
    addVariable() {
      this.userCurrentVariable.push({ ...this.newVariable })
      this.updateCurrentUser()
      this.newVariable = { name: null, value: null }
      this.isAdd = false
    },
    selectUser(item) {
      this.currentUser = { ...item }

      try {
        if (this.currentUser) {
          var result = []
          var variables = JSON.parse(this.currentUser.current_variables)
          for (var key in variables) {
            if (variables.hasOwnProperty(key)) {
              result.push({
                name: key,
                value: variables[key]
              })
            }
          }
          this.userCurrentVariable = result
        } else {
          throw 'no user'
        }
      } catch (error) {
        this.userCurrentVariable = []
      }

      this.showUser = true
    },
    async deleteVariable(index) {
      this.userCurrentVariable = this.userCurrentVariable.filter(el => el.name !== index)

      this.updateCurrentUser()
    },
    updateCurrentUser() {
      var variables = this.userCurrentVariable.reduce(
        (prev, el) => ({ ...prev, [el.name]: el.value }),
        {}
      )
      this.$set(this.currentUser, 'current_variables', JSON.stringify(variables))
      var userIndex = this.users.findIndex(el => el.id == this.currentUser.id)
      if (userIndex != -1) {
        this.$set(this.users, userIndex, this.currentUser)
        this.saveCurrentVariable()
      }
      try {
        var result = []
        for (var key in variables) {
          if (variables.hasOwnProperty(key)) {
            result.push({
              name: key,
              value: variables[key]
            })
          }
        }
        this.userCurrentVariable = result
      } catch (error) {
        console.log(error)
        this.userCurrentVariable = []
      }
      this.timestamp = moment().format('x')
    },
    async getallusersbybotorigin(offset) {
      var request = {
        botorigin: this.selectedBot.pageid,
        limit: 100,
        offset: offset
      }
      var response = await api.getallusersbybotorigin(request)
      return response
    },
    async saveCurrentVariable() {
      var request = {
        params: {
          id: this.currentUser.id
        },
        data: { current_variables: this.currentUser.current_variables }
      }
      await api.saveusercurrentvariables(request)
    }
  },
  watch: {
    showUser: function(newVal) {
      if (!newVal) {
        this.currentUser = null
        this.userCurrentVariable = []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytic/Users.vue